// @generated by scripts/gen-modules.mjs
import { RouteObject, Navigate } from 'react-router-dom';
import { SyncRoutes } from './modules/sync';
import { MigrationRoutes } from './modules/migration';
import { AiRoutes } from './modules/ai';

export const dataRoutes: RouteObject[] = [
  { path: '', element: <Navigate to="sync/native-integrations" replace /> },
  SyncRoutes,
  MigrationRoutes,
  AiRoutes,
];

export default dataRoutes;
